import React from 'react'
import { Box, Button, Chip, Typography } from '@mui/material'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded'
import { ProviderRoleId } from '../../currentRole'
import { advancedColors } from '../../theme'
import { CarePlanStatus, carePlanTitle } from './carePlanState'

type Props = {
  role: ProviderRoleId
  status: CarePlanStatus
  viewOnly: boolean
  editable: boolean
  onEdit: () => void
  onRefresh: () => void
}

const CarePlanHeader = ({ role, status, viewOnly, editable, onEdit, onRefresh }: Props) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography variant="overline">{carePlanTitle(role)}</Typography>
      <Chip
        size="small"
        label={status === 'submitted' ? 'Submitted' : 'Draft'}
        sx={{
          backgroundColor: status === 'submitted' ? advancedColors.accentSoft : advancedColors.cardBg,
          color: status === 'submitted' ? advancedColors.green : advancedColors.inkMuted,
        }}
      />
      {viewOnly ? (
        <Chip
          size="small"
          label="View only"
          sx={{ backgroundColor: advancedColors.cardBg, color: advancedColors.inkMuted }}
        />
      ) : (
        editable && <Chip size="small" label="Editing" sx={{ backgroundColor: advancedColors.lightGreen }} />
      )}
    </Box>
    {!viewOnly && (
      <Box sx={{ display: 'flex', gap: 1 }}>
        <Button size="small" startIcon={<RefreshRoundedIcon fontSize="small" />} onClick={onRefresh}>
          Refresh
        </Button>
        {!editable && (
          <Button size="small" variant="contained" startIcon={<EditRoundedIcon fontSize="small" />} onClick={onEdit}>
            Edit
          </Button>
        )}
      </Box>
    )}
  </Box>
)

export default CarePlanHeader
